import React from 'react';
import { translate } from 'react-i18next';

import {colors, spacings, fontSizes, fonts, layout} from 'style';
import ProgressBar from 'modules/misc/ProgressBar.js';
import RewardClaimModal from './RewardClaimModal.js';
import LoadInline from '../loading/LoadInline.js';
import RewardItem from './RewardItem.js';

import './rewards.css';

var style = {
    content: {
        ...fonts.body,
        lineHeight: '1.5',
        color: colors.themeDarkerGrey,
        position:'relative',
    },
    group: {
        paddingTop: spacings.small,
        paddingBottom: spacings.small,
        paddingLeft: '0px',
        paddingRight: '0px',
        marginTop: '0',
    },
    body: {
        maxWidth: layout.screenWidth,
        boxShadow: layout.screenShadow,
        minHeight: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: 'white',
    },
    bodyWithBanner: {
        minHeight: 'calc(100% - 40px)',
    },
    disclaimer: {
        padding: spacings.base,
    },
    progressInfo: {
        paddingTop: spacings.small,
        paddingLeft: '80px',
        paddingRight: '80px',
        height: '64px',
        backgroundColor: colors.themeBlue,
        color: '#fff',
    },
    progressContainer:{
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: layout.screenWidth,
        paddingLeft: spacings.base,
        paddingRight: spacings.base,
    },
    levelText: {
        paddingTop: '3px',
        fontWeight: 'light',
        fontSize: '0.95em',
        textAlign: 'center',
    },
    progressBar: {
        height: '12px',
        backgroundColor: '#fff',
    },
};

const Rewards = ({t, rewards, busy, monthlyClaims, monthlyClaimsLimit, claimButtonDisable, onRedeemReward, redeemResult, onHideModal}) => (
    <div className="full-height" style={style.content}>
        {monthlyClaimsLimit !== undefined &&
            <div style={style.progressInfo} className='rewards-progressInfo'>
                <div style={style.progressContainer}>
                    <ProgressBar style={style.progressBar} value={monthlyClaims} total={monthlyClaimsLimit} borderWidth={'0'} />
                    <div style={style.levelText}>
                        {t('claims_limit_[val]_[limit]',{val:monthlyClaims, limit:monthlyClaimsLimit})}
                    </div>
                </div>
            </div>
        }
        {busy && 
            <LoadInline centered vcentered /> 
        }
        {!busy && 
        <div style={{...style.body, ...(monthlyClaimsLimit !== undefined ? style.bodyWithBanner : {})}}>
            <div style={style.group}>
            {rewards.map((reward)=> (
                        <RewardItem key={reward.id} 
                                    reward={reward}
                                    claimButtonDisable={claimButtonDisable}
                                    onRedeemReward={onRedeemReward} />
                    ) 
                )    
            }
            </div>
            <div style={style.disclaimer}>
                {t('rewards_disclaimer')}
            </div>
        </div>
        }
        <div></div>
        {redeemResult &&
            <RewardClaimModal reward={redeemResult.reward} success={redeemResult.success} onClose={onHideModal} />
        }
    </div>
);


export default translate('rewards')(Rewards);



// WEBPACK FOOTER //
// ./src/modules/rewards/Rewards.js